import Cookies from 'cookies-js';
import { v4 as uuidv4 } from 'uuid';

import type { Profile } from '../@types/Profile';
import type { Token } from '../@types/Token';
import type { TrackEvent } from '../@types/Tracking';

const SESSION_NAME = 'wayke-sid';

const createSessionId = () => {
  const id = uuidv4();
  Cookies.set(SESSION_NAME, id, {
    path: '/',
  });
  return id;
};

const getSessionId = () => Cookies.get(SESSION_NAME) || createSessionId();
const getEmail = (token?: Token) => token?.email;
const getIdp = (token?: Token) => token?.idp;
const getSub = (token?: Token) => token?.sub;

const getUser = (token: Token | undefined, profile: Profile | undefined) => ({
  email: getEmail(token),
  givenName: profile?.givenName,
  familyName: profile?.familyName,
  login: true,
  userId: getSub(token),
  sessionId: getSessionId(),
  userType: 'dealer',
  idp: getIdp(token),
});

const trackWithUser = (
  decodedToken: Token | undefined,
  profile: Profile | undefined,
  data: TrackEvent,
): TrackEvent => {
  const trackData = {
    userData: getUser(decodedToken, profile),
    ...data,
  };

  return trackData;
};

export default trackWithUser;
